/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this))
    );
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const addOnItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');
    const collectionPageBundle = document.querySelector('.charm-bar-page');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)));
    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll(
        '[data-addon-selection]:checked'
      );
      addOnItemsEle.forEach((addOn) => {
        if (addOn.disabled == false) {
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value,
          };
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems,
    });

    //if (submitButton.dataset.handle === 'byob-test') {
    if (collectionPageBundle) {
      window.collection.charmBar.addProductToList(addItems, evt);
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
      return;
    }

    fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (document.querySelector('#PopupModal-quickshop')) {
          document
            .querySelector('#PopupModal-quickshop .close-quickshop')
            .dispatchEvent(new Event('click'));
        }



        //this.cartElement.getCartData('open_drawer');

        // Open Rebuy Smart Cart after successful add (same as PDP flow).
        // Rebuy listens for `rebuy:cart.add` to refresh and reveal the side cart;
        // we also call SmartCart.show() defensively in case the event isn't bound yet.
        let smartCartOpened = false;
        try {
          document.dispatchEvent(
            new CustomEvent('rebuy:cart.add', { detail: parsedState })
          );
          if (window.Rebuy) {
            if (window.Rebuy.Cart && typeof window.Rebuy.Cart.refreshCart === 'function') {
              window.Rebuy.Cart.refreshCart();
            }
            if (window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
              window.Rebuy.SmartCart.show();
              smartCartOpened = true;
            }
          }
        } catch (err) {
          console.error('Rebuy side cart open failed:', err);
        }

        // Rebuy can be unavailable when a visitor rejects optional cookies.
        // Keep the core purchase flow usable by showing Shopify's cart page.
        if (!smartCartOpened) {
          window.location.assign(routes.cart_fetch_url || '/cart');
        }

        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Remove loading state from button after 2 second delay
        setTimeout(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        }, 2000);
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget
      .closest('[data-qty-container]')
      .querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelectorAll('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    this.someSticky();

    if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  someSticky() {
    linkMainFormToSticky();
    const customSelects = this.form.querySelectorAll(
      '.sticky-variant .product-form__input'
    );
    const _this = this;

    // Iterate on each custom “select” container
    customSelects.forEach(function (customSelect) {
      const selectSelected = customSelect.querySelector('.select-selected');
      const selectItems = customSelect.querySelector('.select-items');
      const hiddenSelect = customSelect.querySelector('.select .form-select');

      // Función para actualizar el "select" personalizado
      function updateCustomSelect() {
        const selectedOption = hiddenSelect.options[hiddenSelect.selectedIndex];
        const textItem = selectedOption?.textContent.trim();
        selectSelected.textContent = textItem;
        _this.onVariantChange('load');
        changeTextBtn(textItem);

        const form = selectItems.closest('form');
        const idVariant = form.querySelector('input[name="id"]').value;
        const inputs = document.querySelectorAll(
          '.product-details-wrapper form input[name="id"]'
        );
        inputs.forEach((input) => {
          input.value = idVariant;
        });
      }

      // Initialize custom select with hidden select value
      updateCustomSelect();

      // Listening to changes in the hidden select
      hiddenSelect.addEventListener('change', updateCustomSelect);

      // Click on the “select” button to select the custom button.
      selectSelected.addEventListener('click', function (e) {
        // Close all open selectors before opening the current one.
        closeAllSelects(customSelect);

        customSelect.classList.toggle('active');
        selectItems.classList.toggle('select-hide'); // Show/hide options
        e.stopPropagation(); // Stop the propagation of the event so as not to close it immediately
      });

      // Listen to click on the options of the custom “select”.
      selectItems.addEventListener('click', function (event) {
        if (event.target.tagName === 'DIV') {
          selectSelected.textContent = event.target.textContent;
          hiddenSelect.value = event.target.getAttribute('data-value');

          customSelect.classList.remove('active');
          selectItems.classList.add('select-hide');

          Array.from(hiddenSelect.options).forEach((option) => {
            option.removeAttribute('selected');
          });

          hiddenSelect
            .querySelector(
              `option[value='${event.target.getAttribute('data-value')}']`
            )
            .setAttribute('selected', 'selected');

          hiddenSelect.dispatchEvent(new Event('click'));
          hiddenSelect.dispatchEvent(new Event('change'));
          linkStickyToMainForm(event.target.getAttribute('data-value'));
        }
      });

      // Function to close all open selectors except the current one
      function closeAllSelects(currentSelect) {
        customSelects.forEach(function (otherSelect) {
          if (otherSelect !== currentSelect) {
            otherSelect.classList.remove('active');
            const otherItems = otherSelect.querySelector('.select-items');
            if (otherItems) {
              otherItems.classList.add('select-hide');
            }
          }
        });
      }

      function adjustVariantDisplay(ele, btnSticky) {
        const screenWidth = window.innerWidth;
        const outText = ele.getAttribute('data-out');

        const text =
          screenWidth > 800
            ? ele.getAttribute('data-desk')
            : ele.getAttribute('data-mobile');

        if (!btnSticky.getAttribute('disabled')) {
          btnSticky.querySelector('.add-text-mobile').innerHTML = text;
          btnSticky.querySelector('.add-text').innerHTML = text;
        } else {
          btnSticky.querySelector('.add-text-mobile').innerHTML = outText;
          btnSticky.querySelector('.add-text').innerHTML = outText;
        }
      }

      function changeTextBtn(textItem) {
        const screenW = screen.width;
        const items = document.querySelectorAll('.select-items');
        items.forEach((item) => {
          item.querySelectorAll('div').forEach((ele) => {
            if (ele.textContent === textItem) {
              const btnSticky = document.querySelector('.btn-stiky');

              const img = ele.getAttribute('data-img');
              const controlImg = document.querySelector('.sticky-image img');
              controlImg.src = img;
              controlImg.setAttribute('srcset', `${img}&width=100w`);

              adjustVariantDisplay(ele, btnSticky);

              window.addEventListener(
                'resize',
                adjustVariantDisplay(ele, btnSticky)
              );
            }
          });
        });
      }

      function linkStickyToMainForm(textItem) {
        const items = document.querySelectorAll(
          '.product-details-wrapper form .variant_selector'
        );
        items.forEach((item) => {
          item.querySelectorAll('option').forEach((ele) => {
            ele.removeAttribute('selected');

            if (ele.value === textItem) {
              item.value = textItem;
              ele.setAttribute('selected', 'selected');
              item.dispatchEvent(new Event('change'));
            }
          });
        });
      }

      // Listen to click outside the custom “select” to close it.
      document.addEventListener('click', function (event) {
        if (!customSelect.contains(event.target)) {
          customSelect.classList.remove('active');
          selectItems.classList.add('select-hide');
        }
      });
    });

    function linkMainFormToSticky() {
      const items = document.querySelectorAll(
        '.product-details-wrapper form .variant_selector'
      );
      const stickySelects = document.querySelectorAll(
        '.form-sticky-container form .variant_selector'
      );

      items.forEach((item) => {
        item.addEventListener('change', (event) => {
          const value = event.target.value;

          stickySelects.forEach((element) => {
            element.querySelectorAll('option').forEach((op) => {
              op.removeAttribute('selected');
              if (op.value === value) {
                op.setAttribute('selected', 'selected');
                element.value = value;
                element.dispatchEvent(new Event('change'));
              }
            });
          });
        });
      });
    }
  }

  updateVariantStatuses(event) {
    const selectedOptionOneVariants = this._getVariantData().filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);


      this.setInputAvailability(optionInputs, availableOptionInputsValue, event)
    });
  }

  updateVariantStatusesProductCard(event) {
    let selectedOptionOneVariants = this._getVariantData().filter(variant => this.querySelector(':checked').value === variant.option1);
    if (event?.target.tagName === 'SELECT' && this.form.querySelector('input[type="radio"]')) {
      selectedOptionOneVariants = this._getVariantData().filter(variant => this.form.querySelector('input[type="radio"]:checked').value === variant.option1);
    }

    // Check if we need to update the product image based on color swatch click
    if (event && event.target && event.target.closest('.color-swatch')) {
      // Set the current variant based on selected options
      this.setCurrentVariant();
      
      // If we have a current variant with an image, update the product image
      if (this.currentVariant && this.currentVariant.featured_image) {
        const productGrid = this.closest('[data-product-grid]');
        if (productGrid) {
          const primaryImage = productGrid.querySelector('.img-primary');
          if (primaryImage) {
            // Check if the primary element is a video tag
            if (primaryImage.tagName.toLowerCase() === 'video') {
              // Hide the video
              primaryImage.style.display = 'none';
              
              // Check if we already created a replacement image
              let replacementImg = productGrid.querySelector('.img-primary-replacement');
              if (!replacementImg) {
                // Create a new image element
                replacementImg = document.createElement('img');
                replacementImg.className = 'w-100 img-primary-replacement';
                replacementImg.style.position = 'absolute';
                replacementImg.style.top = '0';
                replacementImg.style.left = '0';
                replacementImg.style.width = '100%';
                replacementImg.style.height = '100%';
                replacementImg.style.objectFit = 'cover';
                
                // Insert the replacement image after the video
                primaryImage.parentNode.insertBefore(replacementImg, primaryImage.nextSibling);
              }
              
              // Update the replacement image source
              replacementImg.src = this.currentVariant.featured_image.src;
              replacementImg.srcset = this.currentVariant.featured_image.src;
            } else {
              // It's an img tag, update normally
              primaryImage.src = this.currentVariant.featured_image.src;
              primaryImage.srcset = this.currentVariant.featured_image.src;
            }
          }
        }
      }
    }

    const inputWrappers = [...this.form.querySelectorAll('.product-form__input')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector('input:checked, option:checked')?.value;
      if (!previousOptionSelected) return;
      
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => {
        return variant[`option${ index }`] === previousOptionSelected
      }).map(variantOption => {
        return variantOption[`option${ index + 1 }`]
      });

      this.setInputAvailability(optionInputs, availableOptionInputsValue, event)
    });
  }

  filterRadioOptions(options, values) {
    return options.filter(option => {
      const value = option.value; // Obtener el valor del radio u opción
      option.style.display = values.includes(value) ? "block" : "none";

      return values.includes(value)
    });
  }

//  Vamos a obtener los valores que no existe y si no es al taget.value del evento change, entra a la logica de actualizar el selected
  setInputAvailability(listOfOptions, listOfAvailableOptions, event) {
    let optionsFilteredByValues = listOfOptions.map(item => item.value)
    optionsFilteredByValues = optionsFilteredByValues.filter(item => listOfAvailableOptions.includes(item))
    const optionsAvailable = this.filterRadioOptions(listOfOptions, optionsFilteredByValues)
    let productPage = this.closest('[data-product-container]');

    if (this.closest('[data-product-grid]')) {
      productPage = this.closest('[data-product-grid]');
    }

    if (event && event !== 'load') {
      this.setCurrentVariant()
      this.renderProductInfo(this.currentVariant, productPage);
      this.updateURLandID(this.currentVariant);

      return
    }

    if (optionsAvailable.length) {
      const wrapper = optionsAvailable[0].closest('select')

      if (wrapper.type === 'radio') {
        optionsAvailable[0].checked = true

        optionsAvailable[0].dispatchEvent(new Event('change'))

        this.setCurrentVariant()
        this.renderProductInfo(this.currentVariant, productPage);
        this.updateURLandID(this.currentVariant);

        return;
      }


      wrapper.value = optionsAvailable[0].value
      wrapper.dispatchEvent(new Event('change'))
      
      this.setCurrentVariant()
      this.renderProductInfo(this.currentVariant, productPage);
      
      this.updateURLandID(this.currentVariant);
    }
  }

  onVariantChange(event) {
    this.showHidePurchases();

    this.setCurrentVariant();
    if (this.formType == 'product-page') {
      window.globalVariables.product.currentVariant = this.currentVariant;
    }


    if (!this.currentVariant) {
      if (this.formType == 'product-page') {
        this.updateVariantStatuses()
      } else {
        console.log('no variant')
        this.updateVariantStatusesProductCard()
      }

      this.toggleAddButton();


      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');

      options.forEach((option) => {
        let lableID = 'option' + option.dataset.optionindex;
        const selectedValue = option.querySelector(
          'input[type="radio"]:checked'
        );
        const lable = option.querySelector('.selected-option');
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        

        if (event) {
          if (event == 'load') {
            templateProductJS.prototype.manageVariantSlider(
              this.currentVariant
            );
          } else if (event) {
            let currentTarget = event.target;
            let pdpContainer = currentTarget.closest(
              '[data-product-container]'
            );
            let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
            let targetName = currentTarget.getAttribute('name') || '';
            targetName = targetName.toLowerCase();

            if (
              pdpContainer &&
              (targetName.indexOf('color') > -1 ||
                targetName.indexOf('options[color]') > -1)
            ) {
              if (quickShopModal) {
                quickShop.prototype.manageVariantSlider(this.currentVariant);
              } else {
                templateProductJS.prototype.manageVariantSlider(
                  this.currentVariant
                );
              }
            }
          }
        }

        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }


      if (this.formType == 'product-page') {
        this.updateVariantStatuses(event)
      } else {
        console.log('variant productcard')
        this.updateVariantStatusesProductCard(event)
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton();
    }
  }

  showHidePurchases() {
    setTimeout(function () {
      const btn = document.querySelector('button.add-to-cart');
      const purchases = document.querySelector('.purchases');
      if (!purchases) return;

      if (btn && btn?.disabled === true) {
        purchases.classList.add('hide');
      } else {
        purchases.classList.remove('hide');
      }
    }, 10);
  }

  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach((link) => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    const _parentForm = this.form
    let options = [];
    _parentForm.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const _parentForm = this.form

    const fieldsets = Array.from(
      _parentForm.querySelectorAll('fieldset:not(.addon-fieldset)')
    );
    const options = fieldsets.map((fieldset) => {
      return Array.from(
        fieldset.querySelectorAll('input:not(.addon-swatch)')
      ).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    const selectOptions = this._getOptionsFromSelect()
    const radioOptions = this._getOptionsFromRadio()
    let options =
      this.variantPicker == 'variant-select'
        ? selectOptions
        : radioOptions;

    if (selectOptions.length && radioOptions.length) {
      options = [...radioOptions, ...selectOptions]
    }

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not

      let mappedValues = variant.options.map(item => options.includes(item));

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    // if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    if (this.formType == 'product-page') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', currentVariant.id);
      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?${url.toString().split('?')[1]}`
      );
    }

    // update variant input with currentVariant Id
    const productContainer = this.form.closest('.card-product ')

    if (productContainer) {
      const inputs = productContainer.querySelectorAll('input[name="id"]')

      inputs.forEach(input => {
        input.value = currentVariant.id;
      })

      return
    }
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    let active_compare = false;
    const modifier_container = container.querySelector('[data-modifier]');

    // Price Update
    let price = Shopify.formatMoney(
      currentVariant.price,
      window.globalVariables.money_format
    );
    let compare_price = Shopify.formatMoney(
      currentVariant.compare_at_price,
      window.globalVariables.money_format
    );

    if (modifier_container) {
      const modifier = modifier_container.dataset.modifier;
      const discounted_value = (currentVariant.price * modifier) / 100
      price = Shopify.formatMoney(
        currentVariant.price - discounted_value,
        window.globalVariables.money_format
      );
      compare_price = Shopify.formatMoney(
        currentVariant.price,
        window.globalVariables.money_format
      );

      if (compare_price == price) {
        compare_price = Shopify.formatMoney(
          currentVariant.compare_at_price,
          window.globalVariables.money_format
        );
      }
      active_compare = true;
    }

    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    // Use querySelector on the container to find the element; guard if it doesn't exist
    let collectionModifiedPriceElement = container.querySelector('#collectionModifiedPriceElement');
    const collectionModifiedPriceValue = collectionModifiedPriceElement
      ? parseInt(collectionModifiedPriceElement.value || '0', 10)
      : 0;

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement && collectionModifiedPriceValue === 0) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price == null) {
        comparePriceElement.style.display = 'none';
        priceElement.classList.remove('with-sale-price');
      } else {
        if (currentVariant.compare_at_price > currentVariant.price) {
          priceElement.classList.add('with-sale-price');
        } else {
          priceElement.classList.remove('with-sale-price');
        }
        comparePriceElement.style.display = 'block';
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      if (!currentVariant.featured_media) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(
        `.product--media[data-mediaID="${imageID}"]`
      );
      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(
          `.quickshop-slider .product--media[data-mediaID="${imageID}"]`
        );
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
        imageSlide
      );
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach((option) => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  toggleAddButton() {
    if (!this.addBtn.length) return;
    this.addBtn.forEach(btn => {
      // Check if variant should show Pre-order (zero stock but continue selling)
      let isVariantPreorder = this.currentVariant && 
        this.currentVariant.available && 
        this.currentVariant.inventory_quantity <= 0 && 
        this.currentVariant.inventory_policy === 'continue';
      
      // Also check product-level preorder from data attribute
      const productGrid = this.form.closest('[data-product-grid]');
      let isProductPreorder = productGrid && productGrid.dataset.preorder === 'true';

      if ((this.currentVariant && !this.currentVariant.available) || !this.currentVariant) {
        btn.setAttribute('disabled', true);
        if (btn.querySelector('.add-text'))
          btn.querySelector('.add-text').textContent =
            window.variantStrings.soldOut;
      } else {
        btn.removeAttribute('disabled');
        if (this.form.classList.contains('cart-upsell-form')) {
          btn.querySelector('.add-text').textContent =
            window.variantStrings.upsellAddText;
        } else {
          if (
            btn.dataset &&
            btn.dataset.collectionType === 'bundle-size'
          ) {
            btn.querySelector('.add-text').textContent =
              btn.dataset.bundleText;
          } else if (isVariantPreorder || isProductPreorder) {
            btn.querySelector('.add-text').textContent = 'Pre-Order';
          } else {
            btn.querySelector('.add-text').textContent =
              window.variantStrings.addToCart;
          }
        }
      }
    })
  }

  _getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }

  _getVariantDataItem(itemText) {
    const data = this._getVariantData();
    return data.find((item) => item.title.includes(itemText)) || null;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach((swatch) => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset
          .handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch
          .querySelector('.swatch-label')
          .setAttribute('style', swatchStyle);
        
        // Add click event to set active class
        const input = swatch.querySelector('input[type="radio"]');
        input.addEventListener('change', () => {
          // Remove active class from all swatches
          colorSwatches.forEach(s => s.classList.remove('swatch-active'));
          // Add active class to selected swatch
          if (input.checked) {
            swatch.classList.add('swatch-active');
          }
        });
        
        // Set initial active state if checked
        if (input.checked) {
          swatch.classList.add('swatch-active');
        }
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);
